/**
 * Pre-fills Shopify Forms with product information
 * Specifically targets the custom#message field within shopify-forms-embed
 */
class ShopifyFormsProductPrefill {
	constructor() {
		this.prefillMessage = window.ShopifyFormsConfig?.prefillMessage || 'I am interested in the product';
		this.init();
	}

	getProductName() {
		// Try multiple selectors to find product name
		const nameElement = document.querySelector(
			'[itemprop="name"], .product__title, .product-title, h1'
		);
		return nameElement ? nameElement.textContent.trim() : '';
	}

	buildMessage(productName) {
		// Build the full message: "I am interested in the product [Product Name]"
		return `${this.prefillMessage} ${productName}`;
	}

	init() {
		console.log('🔍 ShopifyFormsProductPrefill initialized');
		console.log('📝 Prefill message template:', this.prefillMessage);

		// Watch for dialog/popup opening
		document.addEventListener('click', (e) => {
			const popupButton = e.target.closest('.popup-link__button');
			if (!popupButton) return;

			console.log('🎯 Popup button clicked');

			const productName = this.getProductName();
			console.log('📦 Product name:', productName);

			if (!productName) {
				console.warn('⚠️ No product name found');
				return;
			}

			const fullMessage = this.buildMessage(productName);
			console.log('💬 Full message to prefill:', fullMessage);

			// Try multiple times as the form might load asynchronously
			setTimeout(() => this.prefillForm(fullMessage), 100);
			setTimeout(() => this.prefillForm(fullMessage), 300);
			setTimeout(() => this.prefillForm(fullMessage), 600);
			setTimeout(() => this.prefillForm(fullMessage), 1000);
			setTimeout(() => this.prefillForm(fullMessage), 2000);
		});

		// Also watch for DOM mutations (when form is injected)
		this.observeFormInjection();
	}

	/**
	 * Sets field value
	 */
	setFieldValue(field, message) {
		console.log('🔧 Setting field value...');

		// Set the value
		field.value = message;

		// Trigger events
		field.dispatchEvent(new Event('input', { bubbles: true }));
		field.dispatchEvent(new Event('change', { bubbles: true }));

		console.log('✅ Field value set to:', message);
	}

	prefillForm(message) {
		console.log('🔄 Attempting to prefill form with:', message);

		// First, find the shopify-forms-embed element
		const formsEmbed = document.querySelector('shopify-forms-embed');

		if (!formsEmbed) {
			console.warn('❌ shopify-forms-embed element not found');
			return;
		}

		console.log('✅ Found shopify-forms-embed:', formsEmbed);

		// Check if it has a shadow root
		if (formsEmbed.shadowRoot) {
			console.log('🌓 Form uses Shadow DOM');
			this.fillFieldInShadowRoot(formsEmbed.shadowRoot, message);
			return;
		}

		// Otherwise, search within the normal DOM
		console.log('🔍 Searching in normal DOM within shopify-forms-embed');

		// Try different selector variations within the embed
		const selectors = [
			'textarea[name="custom#message"]',
			'textarea[name="custom\\#message"]', // Escaped hash
			'textarea[name*="message"]', // Contains "message"
			'textarea[name*="custom"]', // Contains "custom"
			'[name="custom#message"]', // Any element
			'textarea' // Just get all textareas within the embed
		];

		let found = false;
		for (const selector of selectors) {
			console.log(`🔍 Trying selector within embed: ${selector}`);
			const fields = formsEmbed.querySelectorAll(selector);
			console.log(`  Found ${fields.length} element(s)`);

			if (fields.length > 0) {
				fields.forEach((field, index) => {
					console.log(`  Element ${index}:`, {
						tagName: field.tagName,
						name: field.getAttribute('name'),
						value: field.value,
						element: field
					});

					// Try to fill if it's empty
					if (!field.value) {
						this.setFieldValue(field, message);
						console.log(`✅ Pre-filled field with name="${field.getAttribute('name')}"`);
						found = true;
					}
				});

				if (found) break;
			}
		}

		if (!found) {
			console.warn('❌ Could not find target field within shopify-forms-embed');
			// Debug what's actually inside
			console.log('All elements in shopify-forms-embed:', formsEmbed.querySelectorAll('*'));
		}
	}

	fillFieldInShadowRoot(shadowRoot, message) {
		console.log('🔍 Searching in Shadow DOM');

		const selectors = [
			'textarea[name="custom#message"]',
			'textarea[name*="message"]',
			'textarea'
		];

		for (const selector of selectors) {
			const field = shadowRoot.querySelector(selector);
			if (field && !field.value) {
				this.setFieldValue(field, message);
				console.log(`✅ Pre-filled field in Shadow DOM`);
				return;
			}
		}

		console.warn('❌ Could not find target field in Shadow DOM');
	}

	observeFormInjection() {
		const productName = this.getProductName();
		if (!productName) return;

		const fullMessage = this.buildMessage(productName);

		const observer = new MutationObserver((mutations) => {
			for (const mutation of mutations) {
				if (mutation.addedNodes.length) {
					mutation.addedNodes.forEach(node => {
						if (node.nodeType === 1) {
							// Check if the node itself is shopify-forms-embed
							if (node.tagName === 'SHOPIFY-FORMS-EMBED') {
								console.log('🆕 shopify-forms-embed detected via MutationObserver');
								setTimeout(() => this.prefillForm(fullMessage), 100);
							}
							// Or if it contains shopify-forms-embed
							const embed = node.querySelector ? node.querySelector('shopify-forms-embed') : null;
							if (embed) {
								console.log('🆕 shopify-forms-embed detected inside added node');
								setTimeout(() => this.prefillForm(fullMessage), 100);
							}
						}
					});
				}
			}
		});

		// Observe the document body for form injection
		observer.observe(document.body, {
			childList: true,
			subtree: true
		});
	}
}

// Initialize when DOM is ready
if (document.readyState === 'loading') {
	document.addEventListener('DOMContentLoaded', () => new ShopifyFormsProductPrefill());
} else {
	new ShopifyFormsProductPrefill();
}
